import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75f2ec86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TheSelect__wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Выбрано:", -1))
const _hoisted_3 = { class: "TheSelect__icon" }
const _hoisted_4 = {
  key: 1,
  class: "fas fa-chevron-down arrow"
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "options__empty"
}
const _hoisted_8 = {
  key: 2,
  class: "TheSelect__error"
}
const _hoisted_9 = { class: "error__text" }
const _hoisted_10 = {
  key: 3,
  class: "options__loader"
}
const _hoisted_11 = {
  key: 0,
  class: "TheSelect__validationerror"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["TheSelect", { opened: _ctx.state.is_opened, disabled: _ctx.disabled }]),
      ref: "elementref"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["TheSelect__trigger", { invalid: _ctx.isInvalid }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOptions && _ctx.toggleOptions(...args)))
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(["TheSelect__placeholder", {
                        selected:
                            (!_ctx.multiselect && Boolean(_ctx.value) && Boolean(_ctx.options.length)) ||
                            (_ctx.multiselect && Boolean(_ctx.value.length) && Boolean(_ctx.options.length)),
                    }])
        }, [
          (!_ctx.multiselect && Boolean(_ctx.value) && Boolean(_ctx.options.length))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.selectedOption)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.$slots['option'] && _ctx.$slots['selected-option'])
                        ? _renderSlot(_ctx.$slots, "selected-option", {
                            key: 0,
                            option: _ctx.selectedOption
                          }, undefined, true)
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.selectedOption[_ctx.label]), 1)
                          ], 64))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Выбрано некорректное значение ")
                    ], 64))
              ], 64))
            : (_ctx.multiselect && Boolean(_ctx.value.length) && Boolean(_ctx.options.length))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.selectedOptions.length < 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.$slots['selected-options'])
                          ? _renderSlot(_ctx.$slots, "selected-options", {
                              key: 0,
                              options: _ctx.selectedOptions
                            }, undefined, true)
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_2,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOptions, (selected_option, i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "ml-2",
                                  key: `selected_option-${i}`
                                }, _toDisplayString(selected_option[_ctx.label]), 1))
                              }), 128))
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Выбрано: " + _toDisplayString(_ctx.selectedOptions.length), 1)
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_ctx.placeholder), 1)
                ], 64))
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_openBlock(), _createElementBlock("i", _hoisted_4))
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["TheSelect__options", { 'options--to-top': _ctx.openToTop }]),
        ref: "optionswindow"
      }, [
        (_ctx.searchable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_the_input, {
                autocomplete: false,
                class: "w-full",
                placeholder: "Поиск",
                value: _ctx.state.search_query,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.search_query) = $event)),
                onInput: _ctx.searchOption
              }, null, 8, ["value", "onInput"]),
              (_ctx.selectAll && _ctx.multiselect)
                ? (_openBlock(), _createBlock(_component_checkbox, {
                    key: 0,
                    value: _ctx.isAll,
                    disabled: _ctx.loading,
                    label: "Все",
                    "onUpdate:value": _ctx.onSelectAll,
                    class: "ml-2"
                  }, null, 8, ["value", "disabled", "onUpdate:value"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedItems, (option, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["options__option", {
                        active:
                            (!_ctx.multiselect && _ctx.value === option[_ctx.selectBy]) ||
                            (_ctx.multiselect && _ctx.value.includes(option[_ctx.selectBy])),
                    }]),
            key: `option-${i}`,
            onClick: ($event: any) => (_ctx.emitSelect(option[_ctx.selectBy]))
          }, [
            (_ctx.$slots['option'])
              ? _renderSlot(_ctx.$slots, "option", {
                  key: 0,
                  option: option
                }, undefined, true)
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(option[_ctx.label]), 1)
                ], 64))
          ], 10, _hoisted_6))
        }), 128)),
        (_ctx.sortedItems.length === 0 && !_ctx.failed && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.emptyText), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.failed && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.errorText), 1),
              _createVNode(_component_the_button, {
                onClick: _ctx.emitRefresh,
                class: "primary small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Перезагрузить ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_loader, { class: "primary" })
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ]))
}